import "./InputValueDifference.scss"

const InputValueDifference = (props) => {

    return (
        <div className="input-difference">
            <div className="input-difference__title">
                {props.current ? "Current" : "Original (published)"}
            </div>
            {
                (props.isHtml && props.value) ? (
                    <div className="input-difference__value" dangerouslySetInnerHTML={{ __html: props.value }} />
                ) : (
                        <div className="input-difference__value">
                            {props.value || "(Empty)"}
                        </div>
                    )
            }
        </div>
    )
}

export default InputValueDifference